/**
 * @description: 销售盈利报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="xy-report">
        <div class="xy-list">
            <div class="row row-margin">
                <label class="list-label-2">时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="xyTime">
                        <input type="text" class="form-control laydate-icon" v-model="xyStartTime"> -
                        <input type="text" class="form-control laydate-icon" v-model="xyEndTime">
                    </div>
                </div>
                <label class="list-label-2">门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="xyShop" data-placeholder="请选择门店"></select>
                </div>
                <label class="list-label-4">商品类型:</label>
                <div class="col-md-2">
                    <input class="form-control input-readonly" placeholder="请选择商品类型" v-model="xy_gtype_txt" ref="xy_gtype_txt" @click="xyGtypeFun($event)" readonly>
                    <span class="selection-clear" @click="clear_input('xy_gtype_txt')">×</span>
                    <span class="span-arrow" role="presentation"><b></b></span>
                </div>
                <label class="list-label-4">商品名称:</label>
                <div class="col-md-2">
                    <input class="form-control" placeholder="请输入商品名称" v-model="xy_goods_name">
                </div>
            </div>
            <div class="row row-margin">
                <div>
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="getXyList(1)" style="margin-right: 10px">查询</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getXyExportSet">导出</button>
                </div>
            </div>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="xy_list_table">
                <el-table-column type="index" label="行号"></el-table-column>
                <!-- value.length > '14' ? value.slice(0, 14) + '...' : value -->
                <el-table-column prop="goods_type_name" label="商品类型"></el-table-column>
                <el-table-column prop="goods_name" label="商品名称" min-width="150"></el-table-column>
                <el-table-column prop="goods_unit_name" label="单位"></el-table-column>
                <el-table-column prop="sale_quantity" label="销售数量"></el-table-column>
                <el-table-column prop="give_quantity" label="赠送数量"></el-table-column>
                <el-table-column prop="present_quantity" label="配送数量"></el-table-column>
                <el-table-column prop="amount" label="销售单价"></el-table-column>
                <el-table-column prop="actual_amount" label="折后单价"></el-table-column>
                <el-table-column prop="buying_price" label="进货单价"></el-table-column>
                <el-table-column prop="amount_total" label="销售总额"></el-table-column>
                <el-table-column prop="actual_amount_total" label="折后总额"></el-table-column>
                <el-table-column prop="buying_price_total" label="进货总额"></el-table-column>
                <el-table-column prop="profit" label="盈利"></el-table-column>
                <el-table-column prop="gpm" label="毛利率"></el-table-column>
            </el-table>
            <div class="pagination-row">
                <div>
                    <label class="list-label-6">折后总额合计:</label>
                    <div class="list-total">{{xy_actual_amount_total}}</div>
                    <label class="list-label-6">进货总额合计:</label>
                    <div class="list-total">{{xy_buying_price_total}}</div>
                    <label class="list-label-4">盈利合计:</label>
                    <div class="list-total">{{xy_profit}}</div>
                </div>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="xy_list_page"
                    :total="xy_list_total"
                    @current-change="getXyList">
                </el-pagination>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="xyExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='xyExport_allcheck' @click='xyExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xyExport_checkModel' value="goods_type_name">
                            <label>商品类型</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xyExport_checkModel' value="goods_name">
                            <label>商品名称</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xyExport_checkModel' value="goods_unit_name">
                            <label>单位</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xyExport_checkModel' value="sale_quantity">
                            <label>销售数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xyExport_checkModel' value="give_quantity">
                            <label>赠送数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xyExport_checkModel' value="present_quantity">
                            <label>配送数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xyExport_checkModel' value="amount">
                            <label>销售单价</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xyExport_checkModel' value="actual_amount">
                            <label>折后单价</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xyExport_checkModel' value="buying_price">
                            <label>进货单价</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xyExport_checkModel' value="amount_total">
                            <label>销售总额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xyExport_checkModel' value="actual_amount_total">
                            <label>折后总额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xyExport_checkModel' value="buying_price_total">
                            <label>进货总额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xyExport_checkModel' value="profit">
                            <label>盈利</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xyExport_checkModel' value="gpm">
                            <label>毛利率</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='xyExport_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='xyExport_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- 商品类型弹窗 -->
            <div class="ele-hide" ref="xy_gtype_area">
                <div class="set-export sel-seldiv">
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='xy_gtype_all' @click='xyGtypeAll'>
                            <label>全选</label>
                        </li>
                        <li v-for="item in xy_gtype_data" :key="item.id">
                            <input type="checkbox" v-model='xy_gtype_item' :value="item.id">
                            <label>{{item.name}}</label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                loading: false,
                xyStartTime: "",
                xyEndTime: "",
                xy_goods_name: "",
                xy_gtype_txt: '',
                xy_gtype_all: false,
                c_xy_gtype_all: false,
                xy_gtype_data: [],
                xy_gtype_item: [],
                xy_list_table: [],
				xy_list_page: 1,
                xy_list_total: 0,
                xy_actual_amount_total: '',
                xy_buying_price_total: '',
                xy_profit: '',
                xyExport_allcheck: false,
                c_xyExport_allcheck: false,
                xyExport_checkModel: [],
                xyExport_checkData: ['goods_type_name', 'goods_name', 'goods_unit_name', 'sale_quantity', 'give_quantity', 'present_quantity', 'amount', 'actual_amount', 'buying_price', 'amount_total', 'actual_amount_total', 'buying_price_total', 'profit', 'gpm'],
                xyExport_type: 1,
            }
        },
        watch: {
            xy_gtype_txt: {
                handler: function(val,oldval) {
                    if(val != "") {
                        $(this.$refs.xy_gtype_txt).parent().find('.selection-clear').show();
                    } else {
                        $(this.$refs.xy_gtype_txt).parent().find('.selection-clear').hide();
                    }
                },
                deep: true
            },
            xy_gtype_item: {
                handler: function (val, oldVal) {
                    if(this.xy_gtype_item.length >= this.xy_gtype_data.length) {
                        this.xy_gtype_all = true;
                        this.c_xy_gtype_all = true;
                    } else {
                        this.xy_gtype_all = false;
                        this.c_xy_gtype_all = false;
                    }
                },
                deep: true
            },
            xyExport_checkModel: {
                handler: function (val, oldVal) {
                    if(this.xyExport_checkModel.length >= this.xyExport_checkData.length) {
                        this.xyExport_allcheck = true;
                        this.c_xyExport_allcheck = true;
                    } else {
                        this.xyExport_allcheck = false;
                        this.c_xyExport_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            // 日期
            this.xyStartTime = moment().subtract(1, 'day').format('YYYY-MM-DD 08:00');
            this.xyEndTime = moment().format('YYYY-MM-DD 08:00');
            this.innitDate(); // 日期
            this.shopDatas = [];
            this.innitInput();  // 门店
            this.getXyGoodsType();  // 商品类型
        },
        methods: {
            // 初始化日期插件
            innitDate: function() {
                let _this = this;
                $(_this.$refs.xyTime).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().subtract(1, 'day').toDate(),
                    endDate: moment().toDate(),
                    maxDate: moment().add(1, 'day').toDate(),
                }, function(start, end, label) {
                    _this.xyStartTime = start.format('YYYY-MM-DD 08:00');
                    _this.xyEndTime = end.format('YYYY-MM-DD 08:00');
                });
            },
            // 初始化门店输入框
            innitInput: function() {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                if (v.id != '0') {
                                    _this.shopDatas.push({
                                        id: v.id,
                                        text: v.name
                                    });
                                }
                            });
                            $(_this.$refs.xyShop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            });
                            $(_this.$refs.xyShop).val(data.response.result[1].id).trigger('change');
                            _this.getXyList(1);
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 商品类型
            getXyGoodsType: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": []
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getAllGoodsType",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.xy_gtype_data = data.response.result.data;
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },



            // 清空多选
            clear_input: function() {
                this.xy_gtype_txt = "";
                this.xy_gtype_item = [];
            },
            // 商品类型弹窗
            xyGtypeFun: function(e) {
                let _this = this;
                let c_xy_gtype_item = _this.xy_gtype_item;
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['商品类型', true],
                    area: ['700px', ''], // 宽高
                    content: $(_this.$refs.xy_gtype_area),
                    cancel: function() {
                        // 右上角关闭
                        if(_this.xy_gtype_txt != "") {
                            _this.xy_gtype_item = c_xy_gtype_item;
                            return;
                        }
                        _this.xy_gtype_item = [];
                    }
                }, function() {
                    let texts = [];
                    _this.xy_gtype_data.forEach(function(item) {
                        _this.xy_gtype_item.forEach(function(item2) {
                            if(item.id == item2) {
                                texts.push(item.name);
                            }
                        });
                    });
                    _this.xy_gtype_txt = texts.join(",");
                    layer.closeAll();
                }, function() {
                    if(_this.xy_gtype_txt != "") {
                        _this.xy_gtype_item = c_xy_gtype_item;
                        return;
                    }
                    _this.xy_gtype_item = [];
                });
            },
            // 全选
            xyGtypeAll: function() {
                let _this = this;
                _this.xy_gtype_all = _this.c_xy_gtype_all;
                if(!_this.xy_gtype_all) { // 实现全选
                    _this.xy_gtype_item = [];
                    _this.xy_gtype_data.forEach(function(item) {
                        _this.xy_gtype_item.push(item.id);
                    });
                } else { // 实现反选
                    _this.xy_gtype_item = [];
                }
            },
            getXyList(page) {
				const _this = this;

                _this.loading = true;
                _this.xy_list_page = page
				Vue.axios.post('FinanceReport/profitList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
                            "start_date": _this.xyStartTime,
                            "end_date": _this.xyEndTime,
                            "shop_id": $(_this.$refs.xyShop).val(),
                            "goods_type": _this.xy_gtype_item,
                            "goods_name": _this.xy_goods_name
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.xy_list_total = Number(res.data.response.result.total_data.total);
							_this.xy_actual_amount_total = res.data.response.result.total_data.actual_amount_total;
							_this.xy_buying_price_total = res.data.response.result.total_data.buying_price_total;
							_this.xy_profit = res.data.response.result.total_data.profit;
						}
						_this.xy_list_table = res.data.response.result.data;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
            // 获取导出设置
            getXyExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport/profitListExport"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.xyExport_checkModel = data.response.result.export_fields;
                                _this.xyExport_type = data.response.result.export_type;
                            } else {
                                _this.xyExport_checkModel = _this.xyExport_checkData;
                                _this.xyExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.xyExport_alert)
                }, function() {
                    _this.exportXyList();
                });
            },
            // 导出字段全选
            xyExportCheckedAll: function() {
                let _this = this;
                _this.xyExport_allcheck = _this.c_xyExport_allcheck;
                if(!_this.xyExport_allcheck) { // 实现全选
                    _this.xyExport_checkModel = [];
                    _this.xyExport_checkData.forEach(function(item) {
                        _this.xyExport_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.xyExport_checkModel = [];
                }
            },
            // 点击“导出”按钮
            exportXyList: function() {
                let _this = this,
                    shop_id = $(_this.$refs.xyShop).val();
                let export_fields = JSON.stringify(_this.xyExport_checkModel);
                window.location.href = Vue.ctUrl + "FinanceReport/profitListExport?" +
                    "start_date=" + _this.xyStartTime +
                    "&end_date=" + _this.xyEndTime +
                    "&shop_id=" + shop_id +
                    "&goods_type=" + _this.xy_gtype_item +
                    "&goods_name=" + _this.xy_goods_name +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.xyExport_type;
                //debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },
        }
    }
</script>
<style lang="less" scoped>
    .xy-list {
        .fixed-table-body {
            overflow-x: scroll;
            table {
                width: 1500px;
                max-width: 2000px;
                // table-layout: fixed;
                word-break: break-all;
            }
        }
        .fixed-table-body::-webkit-scrollbar {
            position: absolute;
            top: 0;
            left: 0;
            height: 30px;
        }
    }
</style>